export default {
  label: "Security Center",
  tabs: {
    dashboard: {
      label: "Dashboard",
      activeVulnerabilities: "Aktive Schwachstellen",
      statCards: {
        activeLabel: "Aktiv",
        loadError: "Schwachstellenstatistiken konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
      },
      trendChart: {
        title: "Schwachstellen nach Schweregrad im Zeitverlauf",
        lastMonths: "Letzte {count} Monate",
      },
      resolutionChart: {
        title: "Durchschnittliche CVE-Behebungszeit",
        statusNew: "Neu",
        statusUnderInvestigation: "In Prüfung",
      },
      affectedResourcesWidget: {
        title: "Betroffene Ressourcen",
        devices: "Geräte",
        deploymentGroups: "Rollout-Gruppen",
        softwareRevisions: "Software-Revisionen",
        viewAll: "Alle anzeigen",
      },
    },
    vulnerabilities: {
      label: "Schwachstellen",
      scanInfo: "Scan-Information: Öffentliche CVE-Datenbanken wurden zuletzt am {date} (UTC) abgefragt.",
      // ── Filterbereich ──
      filters: {
        title: "CVEs filtern",
        hideFilters: "Filter ausblenden",
        showFilters: "Filter einblenden",
        clickToFilter: "(*Zum Filtern klicken)",
        byStatus: "Nach Status",
        bySeverity: "Nach Schweregrad",
        byCvssScore: "Nach CVSS-Score",
        byDevices: "Nach Geräten",
        byDeploymentGroups: "Nach Rollout-Gruppen",
        bySoftwares: "Nach Softwares",
        selectDevices: "GERÄTE WÄHLEN",
        editDevices: "GERÄTE BEARBEITEN",
        filterByDevices: "Nach Geräten filtern",
        filterByDeploymentGroups: "Nach Rollout-Gruppen filtern",
        clearAllFilters: "Alle Filter zurücksetzen",
        clearFilter: "Filter zurücksetzen",
        activeFilters: "{count} Aktiv",
        selectDeploymentGroups: "ROLLOUT-GRUPPEN WÄHLEN",
        editDeploymentGroups: "ROLLOUT-GRUPPEN BEARBEITEN",
        filterBySoftwares: "Nach Softwares filtern",
        selectSoftwares: "APPS WÄHLEN",
        editSoftwares: "APPS BEARBEITEN",
        chartsFailedToLoad: "Diagramme konnten nicht geladen werden. Bitte Verbindung prüfen und erneut versuchen.",
        retry: "Erneut versuchen",
      },
      // ── CVE-Liste ──
      cveList: {
        title: "CVE-Liste",
        changeStatus: "Status ändern",
        changeStatusTooltipDisabled: "CVEs auswählen, um den Status zu ändern",
        searchPlaceholder: "CVEs suchen…",
        activelyExploited: "Aktiv ausgenutzt",
        emptyState: "Keine Schwachstellen gefunden",
        emptyStateFiltered: "Keine CVEs entsprechen den aktuellen Filtern",
        columns: {
          cveId: "CVE ID",
          title: "Title",
          scanDate: "Scan-Datum",
          status: "Status",
          severity: "Schweregrad",
          cvssScore: "CVSS-Score",
          component: "Bibliothek",
          software: "Software",
          softwareVersion: "Software-Version",
        },
        pagination: {
          rowsPerPage: "Zeilen pro Seite:",
        },
      },
      // ── Status ──
      statuses: {
        new: "Neu",
        underInvestigation: "In Prüfung",
        notAffected: "Nicht betroffen",
        affected: "Betroffen",
        fixed: "Behoben",
      },
      // ── Schweregrad ──
      severity: {
        critical: "Kritisch",
        high: "Hoch",
        medium: "Mittel",
        low: "Niedrig",
      },
      // ── Security Cell (Tabellenspalte) ──
      securityCell: {
        columnHeader: "Schwachstellen",
        tooltipCritical: "Kritisch: {count}",
        tooltipHigh: "Hoch: {count}",
        tooltipLastScanned: "Letzter Scan: {date}",
        tooltipNoScanData: "Keine Scan-Daten verfügbar",
        tooltipViewInSecurityCenter: "Im Security Center ansehen",
        noVulnerabilities: "0",
      },
      // ── CVE Detailseite ──
      detailPage: {
        back: "Zurück zur Vulnerability-Übersicht",
        notFound: "Schwachstelle nicht gefunden.",
        header: {
          activelyExploited: "Aktiv ausgenutzt",
          epssLabel: "EPSS",
          epssTooltip: "Exploit Prediction Scoring System — Wahrscheinlichkeit der Ausnutzung in freier Wildbahn",
          cvssVector: "CVSS v3 Vektor",
          noScore: "N/V",
          sources: "Quellen",
        },
        meta: {
          published: "NVD Veröffentlichungsdatum",
          nvdLastModified: "NVD Letzte Änderung",
          detected: "Erstmals erkannt",
          cwe: "CWE",
          source: "Quelle",
          cvssScore: "CVSS-Bewertung",
          severity: "Schweregrad",
          status: "Status",
          devices: "Geräte",
          components: "Komponenten",
          viewOnNvd: "Auf NVD ansehen",
          nvdLinkText: "Den offiziellen Eintrag finden Sie hier:",
          unknown: "Unbekannt",
        },
        sections: {
          description: "Beschreibung",
          cveDescription: "CVE-Beschreibung",
          remediation: "Empfohlene Maßnahmen",
          cveUpdates: "CVE-Updates",
          affectedComponents: "Betroffene Komponenten ({count})",
          noDescription: "Keine Beschreibung verfügbar.",
          noRemediation: "Keine Behebungsempfehlungen verfügbar.",
          tabs: {
            cveUpdates: "CVE-Updates",
            cveDescription: "CVE-Beschreibung",
            affectedResources: "Betroffene Ressourcen",
          },
          matrix: {
            vulnerabilityDetails: "Vulnerability-Details",
            severityScoring: "Schweregrad & Bewertung",
            affectedResources: "Betroffene Ressourcen",
          },
        },
        componentsTable: {
          componentName: "Komponente",
          componentVersion: "Version",
          componentPurl: "PURL",
          softwareRevision: "Software-Revision",
          componentType: "Typ",
          status: "Status",
          actions: "Aktionen",
          changeStatus: "Status ändern",
          viewHistory: "Verlauf anzeigen",
          library: "Bibliothek",
          platformComponent: "Plattformkomponente",
          noFindings: "Keine betroffenen Komponenten gefunden.",
        },
        statusChange: {
          title: "Status ändern — {component}",
          successToast: "Status erfolgreich aktualisiert",
        },
        statusHistory: {
          title: "Statusverlauf — {component}",
          noHistory: "Noch keine Statusänderungen erfasst.",
          by: "von {user}",
          byUnknown: "von unbekanntem Nutzer",
          arrowLabel: "→",
        },
        cveActivity: {
          updateCve: "CVE AKTUALISIEREN",
          statusChangedTo: "Status geändert zu",
          statusLabel: "Status",
          system: "System",
          createdOn: "hat diesen Eintrag erstellt am {date}.",
          unknownUser: "Unbekannter Benutzer",
          noActivity: "Noch keine Aktivitäten erfasst.",
        },
      },
      // ── Status-Ändern-Dialog ──
      changeStatusModal: {
        titleSingle: "Status ändern - {cveId}",
        titleBulk: "Status ändern - {count} CVEs",
        addComment: "Kommentar hinzufügen",
        commentRequired: "Kommentar ist erforderlich",
        commentMaxLength: "{count}/300",
        close: "SCHLIESSEN",
        save: "SPEICHERN",
        statusDescriptions: {
          new: "Das CVE wurde erkannt, aber noch nicht überprüft oder bewertet.",
          underInvestigation:
            "Die Auswirkungen der Schwachstelle auf das Produkt sind unbekannt und werden weiter analysiert.",
          notAffected: "Nach der Untersuchung wurde bestätigt, dass die Schwachstelle im Produkt nicht ausnutzbar ist.",
          affected: "Die Schwachstelle ist im Produkt ausnutzbar und stellt ein Sicherheitsrisiko dar.",
          fixed: "Eine neue Produktversion mit einem Fix für diese Schwachstelle wurde veröffentlicht.",
        },
      },
      // ── Betroffene Ressourcen ──
      affectedResources: {
        title: "Betroffene Ressourcen",
        subtitle: "Vom ausgewählten oder gefilterten CVEs betroffene Ressourcen",
        noData: "Keine Daten gefunden",
        tabs: {
          devices: "GERÄTE",
          deploymentGroups: "ROLLOUT-GRUPPEN",
          softwares: "APPS",
        },
        devicesColumns: {
          serialNumber: "Geräte-Seriennummer",
          modelVersion: "Modell & Version",
          asset: "Anlage",
          lastStoreContact: "Letzter Store-Kontakt",
          deploymentGroup: "Rollout-Gruppen",
          tags: "Tags",
        },
        deploymentGroupsColumns: {
          name: "Rollout-Gruppe",
          architecture: "Architektur",
          deviceModel: "Gerätemodell",
          deviceCount: "Anzahl Geräte",
          criticalVulnCount: "Kritische CVEs",
          highVulnCount: "Hohe CVEs",
        },
        softwaresColumns: {
          softwareName: "Software-Name",
          version: "Version",
          status: "Status",
          usage: "Nutzung",
        },
      },
    },
  },
};
